export default "__VITE_ASSET__7028e091__"